import { NavLink } from 'react-router-dom';
import styles from './BottomNav.module.css';

const TABS = [
  { to: '/marketplace', icon: 'storefront', label: 'Market' },
  { to: '/sanctuary', icon: 'nature_people', label: 'Sanctuary' },
  { to: '/community', icon: 'map', label: 'Community' },
  { to: '/solutions', icon: 'grid_view', label: 'Tools' },
];

export function BottomNav() {
  return (
    <nav className={styles.nav}>
      {TABS.map(({ to, icon, label }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) => `${styles.tab} ${isActive ? styles.active : ''}`}
        >
          <span className="material-icons">{icon}</span>
          <span className={styles.label}>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
